import { useInfiniteQuery } from "@tanstack/react-query";
import axios from "axios";
import { convertToOrganizersCalendarDTO, OrganizersCalendarForm } from '../types/OrganizersCalednarTypes'
import { convertDTOToUrlParams } from "../../../shared/shared";


const fetchOrganizersCalendar = async (form: OrganizersCalendarForm) => {
  const myDto = convertToOrganizersCalendarDTO(form);
  const params = convertDTOToUrlParams(myDto);
  const response = await axios.get(`/event-hosts/?${params.toString()}`);
  
  const totalCount = parseInt(response?.headers["x-total-event-hosts-count"] || '0');
  
  return { data: response.data, totalCount };
};

export default function useOrganizersCalendar(form: OrganizersCalendarForm, enabled: boolean = true) {
  const query = useInfiniteQuery({
    queryKey: ["OrganizersCalendar", form],
    queryFn: ({ pageParam = 0 }) => fetchOrganizersCalendar({ ...form, offset: pageParam }),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const allLoaded = allPages.flatMap((page) => page.data).length;
      return allLoaded < lastPage.totalCount ? allLoaded : undefined;
    },
    enabled
  });

  const organizers = query.data?.pages.flatMap((page) => page.data) || [];
  const totalCount = query.data?.pages[0]?.totalCount || 0;

  return {
    ...query,
    organizers,
    totalCount,
  };
}